import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { ICON_DOWNLOAD } from '../extras/icons';
import { useSelector } from 'react-redux';
import moment from 'moment';
import Swal from 'sweetalert2';
import fileDownload from 'js-file-download';

//Axios
import clienteAxios from '../../config/axios';

import { MSG_ERROR_SERVER, MSG_DOWNLOADING } from '../../constants/messages';
import { ErrorMessage, WaitingMessage } from '../extras/toastMessages';

//Types
import videoTypes from '../../constants/videoTypes';
import CommonService from '../../services/CommonService';
//Función principal
const AudienceVideoPlayer = () => {
    //Tomo del store la audiencia
    const audience = useSelector(state => state.audiences.audienceWork);
    //Inicializo el state local
    const [ loading, setLoading ] = useState(false);
    const [ recordings, setRecordings ] = useState([]);
    const [ access, setAccess ] = useState(null);
    //Busco las grabaciones de la audiencia
    useEffect(() => {
        //Si están los datos de la audiencia, busco las grabaciones
        if(audience){
            //Busco las grabaciones
            loadRecordings();
        }
    }, [audience]);
    
    //Función para descargar archivo INVENIET
    const handleDownload = async (record, videoToken) => {
        //Me fijo si hay acta seleccionada
        if(videoToken && record){
            //Hago la consulta
            try{
                //Cargo la espera
                WaitingMessage(MSG_DOWNLOADING);
                //Extraigo la extensión del nombre de archivo
                const fileExt = CommonService.getExtension(record.archivo);
                //Hago la consulta
                const response = await clienteAxios.get(`${process.env.REACT_APP_BACKEND_URL_VIDEO}/${record.id}/inveniet/${videoToken}`, {
                    responseType: 'blob'
                });
                //Oculto la espera
                Swal.close();
                //Genero el nombre del archivo
                let fileName = moment().format('YYYYMMDDHHmmss');
                fileName = `OGA_VIDEO_${fileName}.${fileExt}`;
                //Descargo el archivo
                fileDownload(response.data, fileName);
            }catch(error){
                const response = error.response;
                let data = {
                    data: null,
                    message: MSG_ERROR_SERVER
                };
                //Verifico si hay error
                if(response){
                    data = response.data;
                }
                //Oculto la espera
                Swal.close();
                //Mensaje de error
                ErrorMessage(data.message);
            }
        }else{
            //Muestro mensaje de error
            ErrorMessage('No se encontraron datos del registro seleccionado');
        }
    }
    
    //Manejo la búsqueda de grabaciones
    const loadRecordings = async () => {
        //Cargo la espera
        setLoading(true);
        try{
            //Hago la consulta
            const response = await clienteAxios.get(`/grabacion/audiencia/${audience.id}`);
            //Tomo las activas solamente
            const recordingsData = response.data.filter(r => r.estado === 1);
            //Seteo los datos (sólo activas)
            setRecordings(recordingsData);
            //Si hay datos, busco el permiso
            if(recordingsData && recordingsData.length > 0){
                //Solicito permiso para mostrar los vídeos
                const responseToken = await clienteAxios.post(`/grabacion-acceso/audiencia/${audience.id}`);
                //Tomo los datos
                setAccess(responseToken.data);
            }
            //Oculto la espera
            setLoading(false);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Mensaje de error
            ErrorMessage(data.message);
            //Oculto la espera
            setLoading(false);
        }
    }
    //Renderizo
    return (
        <div className="row">
            <div className="col-12">
                <div className="card shadow mb-4">
                    <div className="card-header py-2 d-flex flex-row align-items-center justify-content-between">
                        <h6 className="m-0 font-weight-bold text-primary">Grabaciones</h6>
                    </div>
                    <div className="card-body example-one">
                        <div className="row">
                            {
                                recordings && access && access.token ? (
                                    recordings.length > 0 ? (
                                        recordings.map((r, index) => (
                                            <div className={`col-md-${Math.round(12/recordings.length)}`} key={`av${r.id}`}>
                                                <h5>Grabación { ++index }</h5>
                                                    {/* Si el video es de tipo INVENIET, muestro botón para descargarlo */}
                                                    {
                                                        (r.tipo == videoTypes.INVENIET) ? 
                                                            (
                                                                <Button block onClick={()=>{handleDownload(r, access.token)}}>
                                                                    <ICON_DOWNLOAD /> DESCARGAR VIDEO
                                                                </Button>
                                                            )
                                                            : 
                                                            (
                                                                <div className="embed-responsive embed-responsive-21by9">
                                                                    <video 
                                                                        id="video1" 
                                                                        className="embed-responsive-item" 
                                                                        src={`${process.env.REACT_APP_BACKEND_URL_VIDEO}/${r.id}/${process.env.REACT_APP_FT_VIDEO}/${access.token}`}
                                                                        width="360" 
                                                                        height="240" 
                                                                        controls 
                                                                        // autoPlay
                                                                    >
                                                                        <track src={`${process.env.REACT_APP_BACKEND_URL_VIDEO}/${r.id}/${process.env.REACT_APP_FT_SUB}/${access.token}`} kind="subtitles" srcLang="es" label="Español" />
                                                                        Lo sentimos. Este vídeo no puede ser reproducido en tu navegador.
                                                                    </video>
                                                                </div>
                                                            )
                                                    }
                                            </div>
                                        ))
                                    ) : null
                                ) : (
                                    <div className="col-12">
                                        No se encontraron datos de grabaciones asociadas
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AudienceVideoPlayer;